import Tooltip from "@material-ui/core/Tooltip";
import SaveIcon from "@material-ui/icons/Save";
import React, { Component } from "react";
import Button from "@material-ui/core/Button";
export class SaveButtons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onClick: props.onClick,
      caption: props.caption,
      hideToolTip: props.hideToolTip,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }
  render() {
    return (
      <span
        style={{
          cursor: "pointer",
          fontSize: "x-larger",
          // marginRight: "0.5em",
          float: "right",
        }}
      >
        {this.state.hideToolTip ? (
          <Button
            className="add"
            size="small"
            onClick={this.onClick.bind(this)}
            style={{
              background: "#1b7189",
              color: "white",
              fontSize: "x-larger",
              textTransform: "capitalize",
              cursor: "pointer",
              float: "right",
              // margin: "0.2em 0.5em 0.3em 0em",
              marginRight: "1rem",
              marginBottom: "1em",
            }}
            startIcon={<SaveIcon />}
          >
            Save
          </Button>
        ) : (
          <Tooltip title="Save">
            <Button
              className="add"
              size="small"
              onClick={this.onClick.bind(this)}
              style={{
                background: "#1b7189",
                color: "white",
                fontSize: "x-larger",
                textTransform: "capitalize",
                cursor: "pointer",
                float: "right",
                // margin: "0.2em 0.5em 0.3em 0em",
                marginRight: "1rem",
                marginBottom: "1em",
              }}
              startIcon={<SaveIcon />}
            >
              Save
            </Button>
          </Tooltip>
        )}
      </span>
    );
  }
}
export default SaveButtons;
